// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__chelF","title":"styles_title__fpSSA","suggestionBox":"styles_suggestionBox__exicT","box":"styles_box__GFAVm","text":"styles_text__fWPCN","emailText":"styles_emailText__DkRa_","emailBold":"styles_emailBold__72PV3","contactLink":"styles_contactLink__zJUxU"};
module.exports.__checksum = "c8187eed803f"
